import React from 'react';
import {
  Card,
  CardTitle,
  FormGroup,
  Label,
  Input,
  Button,
  Row,
  Col,
} from 'reactstrap';
import Required from 'components/Required';
import UploaderMultiple from 'components/UploaderMultiple';
import {
  BajaStaffMultiple as BajaStaffMultipleType,
  StaffMultipleRequest,
  StaffConsultorio,
} from 'types/Staff';

type SetData = React.Dispatch<React.SetStateAction<StaffMultipleRequest>>;

interface Props {
  isLoading: boolean;
  staff: BajaStaffMultipleType;
  data: StaffMultipleRequest;
  setData: SetData;
  formValidation: Record<string, boolean>;
  allStaff: StaffConsultorio[];
  eliminarBajaStaff:(index: number) => void;
  canUpdateByState?: boolean;
  canUpdateAttachs?: boolean;
}

export default function BajaStaffMultiple({
  isLoading,
  staff,
  data,
  setData,
  formValidation,
  allStaff,
  eliminarBajaStaff,
  canUpdateByState = true,
  canUpdateAttachs = true,
}: Props) {
  return (
    <Card
      id={`${staff.id}`}
      style={{ padding: '20px 40px' }}
    >
      <Row>
        <Col sm={10}>
          <CardTitle>Eliminar Staff</CardTitle>
        </Col>
        <Col sm={2} className='text-right'>
          <Button
            color='danger'
            type='button'
            onClick={() => eliminarBajaStaff(staff.id)}
            size='sm'
            disabled={isLoading || !canUpdateByState}
          >
            ✕
          </Button>
        </Col>
      </Row>
      <FormGroup>
        <Row className="mt-2 mb-2">
          <Col md="6">
            <Label for={`matricula_${staff.id}`}>
              Matriculado <Required />
            </Label>
            <Input
              id={`matricula_${staff.id}`}
              name={`matricula_${staff.id}`}
              type="select"
              className="custom-select form-control"
              value={staff.matriculate_id ?? ''}
              invalid={formValidation[`matricula_${staff.id}`] === false}
              onChange={e =>
                setData({
                  ...data,
                  staff_baja: data.staff_baja.map(item => {
                    return item.id === staff.id
                      ? { ...item, matriculate_id: +e.target.value }
                      : item;
                  }),
                })
              }
              disabled={isLoading || !canUpdateByState}
              required
            >
              <option value="">Seleccione una opción...</option>
              {allStaff?.map(item => {
                return (
                  <option
                    key={item.matricula}
                    value={item.matricula}
                  >
                    {item.matricula} - {item.apellido} {item.nombre}
                  </option>
                );
              })}
            </Input>
          </Col>
          <Col md="6">
            <Label for={`constancia_cuit_${staff.matriculate_id}`}>
              Constancia de CUIT del profesional de la kinesiología <Required />
            </Label><br/>
            <UploaderMultiple
              name={`constancia_cuit_${staff.matriculate_id}`}
              required
              accept={['application/pdf']}
              multiple
              attachs={staff.attachs}
              canUpdateAttachs={canUpdateAttachs}
            />
          </Col>
        </Row>
      </FormGroup>
    </Card>
  );
}
